export const UPDATE_PROMOTION = 'UPDATE_PROMOTION';

export const requestPromotion = promotion => ({
    type: UPDATE_PROMOTION,
    promotion
});
